/**
 * @fileoverview WSF Terminals Cache Flush Date Input Schema
 *
 * Re-exports shared cache flush date input schema for consistency.
 */

export {
  type CacheFlushDateInput,
  cacheFlushDateInputSchema,
} from "@/apis/shared/cacheFlushDate";
